{
  "common": {
    "cancel": "Afbreken",
    "delete": "Verwijderen",
    "remove": "Verwijderen",
    "edit": "Veranderen",
    "restore": "Restore",
    "back": "Back",
    "submit": "opslaan",
    "continue": "Continue",
    "save": "Opslaan",
    "done": "Done",
    "home": "Home",
    "noData": "No data.",
    "confirm": "Confirm",
    "more": "Meer",
    "close": "Close",
    "loading": "Loading",
    "menu": "Menu",
    "reset": "Terugzetten",
    "search": "Zoeken"
  },
  "pageMetaResolver": {
    "category": {
      "title": "{{count}} resultaten voor {{query}}",
      "title_plural": "{{count}} resultaten voor {{query}}"
    },
    "checkout": {
      "title": "Uw bestelling",
      "title_plural": "Uw bestelling"
    },
    "search": {
      "title": "{{count}} resultaten voor \"{{query}}\"",
      "title_plural": "{{count}} resultaten voor \"{{query}}\"",
      "findProductTitle": "{{count}} resultaten voor coupon \"{{coupon}}\"",
      "findProductTitle_plural": "{{count}} resultaten voor coupon \"{{coupon}}\""
    },
    "product": {
      "description": "{{description}}",
      "heading": "{{heading}}",
      "title": "{{title}}"
    }
  },
  "spinner": {
    "loading": "Loading..."
  },
  "navigation": {
    "shopAll": "Shop all {{ navNode}} >"
  },
  "searchBox": {
    "placeholder": "Artikelnaam, omschrijving",
    "help": {
      "insufficientChars": "Please type more characters",
      "noMatch": "Uw zoekopdracht heeft geen resultaten opgeleverd.",
      "exactMatch": "{{ term }}",
      "empty": "Ask us anything"
    }
  },
  "sorting": {
    "date": "Date",
    "orderNumber": "Order Number",
    "rma": "Return Number",
    "replenishmentNumber": "Replenishment Number",
    "nextOrderDate": "Next Order Date"
  },
  "httpHandlers": {
    "badRequest": {
      "bad_credentials": "Onjuiste inloggegevens. Corrigeer de gegevens en probeer het opnieuw.",
      "user_is_disabled": "De gebruiker is gedeactiveerd. Contacteer ons alsjeblieft."
    },
    "badGateway": "A server error occurred. Please try again later.",
    "badRequestPleaseLoginAgain": "De ingegeven gebruiker of het ingegeven wachtwoord is niet correct. Voer de informatie opnieuw in.",
    "badRequestOldPasswordIncorrect": "Oud wachtwoord onjuist",
    "badRequestGuestDuplicateEmail": "{{ errorMessage }} email already exist. Please checkout with a different email to register using a guest account.",
    "conflict": "Already exists.",
    "erpTimeout": "Due to a technical fault, this function is currently not available. Please try again later.",
    "forbidden": "U heeft geen toestemming om deze actie uit te voeren. Neem contact op met uw beheerder als u denkt dat dit een fout is.",
    "gatewayTimeout": "The server did not respond, please try again later.",
    "internalServerError": "An Internal Server Error occurred. Please try again later.",
    "sessionExpired": "Uw sessie is verlopen. Log opnieuw in.",
    "unknownError": "An unknown error occurred",
    "wrongCmsSiteError": "U kunt alleen inloggen in {{ shopName }}, u wordt nu omgeleid en moet zich hier opnieuw aanmelden",
    "resetPasswordNotAllowedError": "U bent een subgebruiker of een tak van dit bedrijf. Uw wachtwoord kan niet automatisch worden verzonden, het moet worden gewijzigd door de eigenaar van uw bedrijf in het gedeelte Mijn RIO.",
    "unknownIdentifierError": "{{ errorMessage }}",
    "illegalArgumentError": "{{ errorMessage }}",
    "unauthorized": {
      "common": "An unknown authorization error occured",
      "invalid_client": "Bad client credentials"
    },
    "validationErrors": {
      "missing": {
        "card_cardType": "The selected credit card is not supported. Please select another.",
        "card_accountNumber": "The credit card number entered is not valid.",
        "card_cvNumber": "The security code entered is not valid.",
        "card_expirationMonth": "The credit card expiration date entered is not valid.",
        "card_expirationYear": "The credit card expiration date entered is not valid.",
        "billTo_firstName": "The first name entered is not valid.",
        "billTo_lastName": "The last name entered is not valid.",
        "billTo_street1": "The address entered is not valid.",
        "billTo_street2": "The address entered is not valid.",
        "billTo_city": "The city entered is not valid for this credit card.",
        "billTo_state": "The state/province entered is not valid for this credit card.",
        "billTo_country": "The country entered is not valid for this credit card.",
        "billTo_postalCode": "The zip/postal code is not valid for this credit card.",
        "country": {
          "isocode": "Missing country"
        }
      },
      "invalid": {
        "card_expirationMonth": "The credit card expiration date entered is not valid.",
        "firstName": "Vorname hat kein gültiges Format.",
        "newPassword": "Voer een wachtwoord in dat verschilt van de laatste 4 gebruikte wachtwoorden.",
        "lastName": "Nachname hat kein gültiges Format.",
        "password": "Password entered is not valid.",
        "uid": "UID is not valid.",
        "code": "Code ist ungültig.",
        "email": "E-mail ist ungültig.",
        "passwordPolicyException": "Helaas kon het nieuwe wachtwoord niet worden opgeslagen. Zorg er ook voor dat het nieuwe wachtwoord verschilt van de laatste vier wachtwoorden die u hebt gebruikt."
      }
    },
    "cartNotFound": "Cart not found.",
    "invalidCodeProvided": "Invalid code provided."
  },
  "miniCart": {
    "item": "{{count}} item currently in your cart",
    "item_plural": "{{count}} items currently in your cart",
    "total": "{{total}}",
    "count": "{{count}}"
  },
  "miniLogin": {
    "userGreeting": "{{name}}",
    "signInRegister": "Aanmelden"
  },
  "skipLink": {
    "skipTo": "Skip to",
    "labels": {
      "header": "Header",
      "main": "Main Content",
      "footer": "Footer",
      "productFacets": "Product Facets",
      "productList": "Product List"
    }
  },
  "formErrors": {
    "labeled": {
      "required": "Veld {{label}} is verplicht",
      "cxInvalidEmail": "Veld {{label}} heeft geen geldig e-mailformaat. Het moet overeenkomen met het volgende patroon: beispiel@ihredomäne.com",
      "cxInvalidPassword": "Veld {{label}} heeft geen geldig wachtwoord",
      "cxMinOneUpperCaseCharacter": "Wachtwoord moet ten minste één hoofdletter bevatten",
      "cxMinOneDigit": "Wachtwoord moet ten minste één cijfer bevatten. ",
      "cxMinOneSpecialCharacter": "Wachtwoord moet ten minste één speciaal teken bevatten",
      "cxMinSixCharactersLength": "Wachtwoord moet ten minste 6 tekens bevatten",
      "cxMinEightCharactersLength": "Wachtwoord moet minimaal 8 tekens bevatten",
      "cxMaxCharactersLength": "Wachtwoord mag niet meer dan 128 tekens bevatten",
      "cxContainsSpecialCharacters": "Wachtwoord mag geen speciale tekens bevatten",
      "cxNoConsecutiveCharacters": "Wachtwoord mag geen opeenvolgende identieke tekens bevatten",
      "date": {
        "required": "Veld {{label}} is verplicht",
        "min": "Veld {{label}} mag niet eerder zijn dan {{min}}",
        "max": "Veld {{label}} mag niet na {{max}} liggen",
        "pattern": "Gebruik datumnotatie jjjj-mm-dd in veld {{label}}",
        "invalid": "Gebruik een geldige datum in veld {{label}}"
      }
    },
    "globalMessage": "The form you are trying to submit contains errors.",
    "required": "Dit veld is verplicht",
    "cxInvalidEmail": "Het door u ingevulde e-mailadres is onjuist.",
    "cxInvalidPassword": "Dit is geen geldig wachtwoordformaat",
    "cxPasswordsMustMatch": "Wachtwoordvelden moeten overeenkomen",
    "cxEmailsMustMatch": "E-mail velden moeten overeenkomen",
    "cxStarRatingEmpty": "Rating field is required",
    "cxNoSelectedItemToCancel": "Select at least one item",
    "cxNegativeAmount": "Amount must be equal or greater than zero",
    "cxContainsSpecialCharacters": "Field cannot contain special characters",
    "invalidTime": "De openingstijd moet in UU:MM aangeven zijn",
    "min": "Hoeveelheid mag niet minder zijn dan {{min}}.",
    "date": {
      "required": "Dit veld is verplicht",
      "min": "Date cannot be before {{min}}",
      "max": "Date cannot be after {{max}}",
      "pattern": "Use dateformat yyyy-mm-dd",
      "invalid": "Use a valid date"
    }
  },
  "formLegend": {
    "required": "De volgende velden met een  \"*\" zijn verplicht."
  },
  "errorHandlers": {
    "scriptFailedToLoad": "Failed to load the script.",
    "refreshThePage": "Please refresh the page."
  },
  "customLoginPage": {
    "badRequest": {
      "bad_credentials": "Onjuiste inloggegevens. Corrigeer de gegevens en probeer het opnieuw.",
      "user_is_disabled": "De gebruiker is gedeactiveerd. Contacteer ons alsjeblieft."
    }
  }
}
